<template>
  <v-container fluid>
    <v-card class="my-5">
      <v-card-title>Sync Course Schedule without End Dates</v-card-title>
      <v-card-subtitle>
        Append additional end dates to course_schedule, teacher_schedule without end date.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="syncSchedules" :disabled="isAppLoading">Sync Schedule</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-card-title>Sync Courses with Google Classroom</v-card-title>
      <v-card-text>
        <v-radio-group label="Sync Mode" v-model="syncMode" :mandatory="false">
          <v-radio label="Sync All Courses" value="all"></v-radio>
          <v-radio label="Sync Single Course" value="single"></v-radio>
        </v-radio-group>

        <v-text-field
          v-if="syncMode == 'single'"
          label="Google Course ID"
          v-model="googleCourseId"
        />
        <v-select
          chips
          label="Sync Fields"
          multiple
          v-model="syncRequestFields"
          :items="syncEntities"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="sync" :disabled="isAppLoading">Sync</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>


    <v-card>
      <v-card-title>Sync Google Meet records</v-card-title>
      
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="syncGoogleMeetRecords" :disabled="isAppLoading">Sync</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>

    <v-card v-if="course">
      <v-card-title>Sync results</v-card-title>
      <p>{{course}}</p>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      courses: [],
      googleCourseId: "",
      course: null,
      syncEntities: [
        "COURSE",
        "TOPIC",
        "TEACHER",
        "STUDENT",
        "INVITATION",
        "RP",
        "COURSEWORK",
        "COURSESCHEDULE", 
        "STANDARD", 
        "COURSE_MATERIALS"
      ],
      syncRequestFields: ["COURSE"],
      syncMode: "all"
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"])
  },
  methods: {
    ...mapActions(["addSuccessMessage"]),
    sync() {
      if (this.syncMode == "all") {
        this.syncAllCourses();
      } else if (this.syncMode == "single") {
        this.syncCourse();
      }
    },
    syncAllCourses() {
      const data = { requestFields: this.syncRequestFields };
      this.$axios.post("/classroom/syncAll", data).then(resp => {
        this.courses = resp.data;
        this.addSuccessMessage("Sync completed")
      });
    },
    syncCourse() {
      const data = {
        googleCourseIds: [this.googleCourseId],
        requestFields: this.syncRequestFields
      };
      this.$axios.post("/classroom/syncCourses", data).then(resp => {
        this.course = resp.data;
        this.addSuccessMessage("Sync completed")
      });
    },
    syncSchedules(){
      const data = {
      };
      this.$axios.post("/course-schedule/append-dates", data).then( () => {
        this.addSuccessMessage("Sync Schedules completed")
      });
    },
    syncGoogleMeetRecords(){
      const data = {
      };
      this.$axios.post("/api/sync-google-meet-records", data).then( () => {
        this.addSuccessMessage("Sync completed for google meet records")
      });
    }
  }
};
</script>

<style>
</style>